/*
  Era & Co immersive opening — see sections/era-immersive.liquid.

  The buy bar lives here, plus one class toggle for the overlay layout: while
  the first full-screen slide is still under the header, .page-wrapper gets
  `era-imm-over-slide` so the CSS can keep Horizon's sticky header
  transparent; below slide 1 the class goes and the normal header returns.
  The photos themselves have no script: no filter, no blur, no pinning, no
  scroll effects.

  Scrolling in Horizon happens in two different places. Under 990px the
  window scrolls. From 990px up, html/body are overflow: hidden and the
  DIV.page-wrapper is the scroll container (overflow-y: auto), so
  window.scrollY stays 0 and window scroll events never fire. The bar
  therefore finds the real scroll container first (nearest ancestor of the
  section whose computed overflow-y is auto or scroll, else the window) and
  measures against that container's own box.

  The bar shows while the main product section's buy buttons are still
  below the container's bottom edge and hides once they come into view
  (Horizon's own sticky bar takes over after they scroll past). The button
  scrolls to the variant picker (multi-variant) or the buy buttons (single
  variant) and moves focus there. No cart logic of its own.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-era-imm]'); /* null when the product has no slides */
  var bar = document.querySelector('[data-era-imm-bar]');
  if (!bar) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    reduceMotion = false;
  }

  /* ---------- Scroll container ---------- */
  var findScroller = function (el) {
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var oy = window.getComputedStyle(node).overflowY;
      if (oy === 'auto' || oy === 'scroll') return node;
      node = node.parentElement;
    }
    return window;
  };

  var scroller = findScroller(root || bar);
  var scrollerIsWindow = scroller === window;

  /* The container's visible box in viewport coordinates. */
  var viewBox = function () {
    if (scrollerIsWindow) {
      return { top: 0, height: window.innerHeight || document.documentElement.clientHeight || 1 };
    }
    var r = scroller.getBoundingClientRect();
    return { top: r.top, height: scroller.clientHeight || r.height || 1 };
  };

  var padTarget = scrollerIsWindow ? document.body : scroller;

  /* ---------- Buy bar ---------- */
  var buyButtons = document.querySelector('.buy-buttons-block');
  var picker = document.querySelector('variant-picker');
  var wantsVariants = bar.getAttribute('data-target') === 'variants';
  var scrollTarget = (wantsVariants && picker) || buyButtons || picker;

  var setBarHeight = function () {
    var h = bar.offsetHeight || 72;
    document.documentElement.style.setProperty('--era-imm-bar-height', h + 'px');
  };

  var shown = false;
  var showBar = function () {
    if (shown) return;
    shown = true;
    bar.hidden = false;
    setBarHeight();
    padTarget.classList.add('era-imm-bar-open');
  };
  var hideBar = function () {
    if (!shown) return;
    shown = false;
    bar.hidden = true;
    padTarget.classList.remove('era-imm-bar-open');
  };

  /* Show while the buy buttons are still below the container's bottom edge. */
  var decide = function () {
    var box = viewBox();
    var bottomEdge = box.top + box.height;
    if (!buyButtons) {
      if (!root) {
        showBar();
        return;
      }
      var r = root.getBoundingClientRect();
      if (r.bottom > box.top && r.top < bottomEdge) showBar();
      else hideBar();
      return;
    }
    var rect = buyButtons.getBoundingClientRect();
    if (rect.top >= bottomEdge) showBar();
    else hideBar();
  };

  /* ---------- Transparent header over slide 1 (overlay layout) ---------- */
  var firstSlide = root && root.classList.contains('era-imm--overlay')
    ? root.querySelector('.era-imm__stack > .era-imm__photo')
    : null;
  var header = document.getElementById('header-component');
  var pageWrapper = document.querySelector('.page-wrapper') || document.body;
  var overSlide = function () {
    if (!firstSlide || !header || !header.hasAttribute('transparent')) return;
    var slideBottom = firstSlide.getBoundingClientRect().bottom;
    var headerBottom = header.getBoundingClientRect().bottom;
    if (slideBottom > headerBottom + 1) pageWrapper.classList.add('era-imm-over-slide');
    else pageWrapper.classList.remove('era-imm-over-slide');
  };

  var ticking = false;
  var requestDecide = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      decide();
      overSlide();
    });
  };

  if ('IntersectionObserver' in window) {
    var barIo = new IntersectionObserver(requestDecide, {
      root: scrollerIsWindow ? null : scroller,
      threshold: [0, 0.01]
    });
    barIo.observe(buyButtons || root);
  }
  scroller.addEventListener('scroll', requestDecide, { passive: true });
  window.addEventListener('resize', function () {
    setBarHeight();
    requestDecide();
  }, { passive: true });
  window.addEventListener('load', requestDecide);
  window.addEventListener('pageshow', requestDecide);
  decide();
  overSlide();

  var button = bar.querySelector('[data-era-imm-buy]');
  if (button) {
    button.addEventListener('click', function () {
      if (!scrollTarget) return;
      scrollTarget.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'center'
      });

      var focusable = null;
      if (wantsVariants) {
        focusable = scrollTarget.querySelector(
          'input:not([disabled]), select:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
      } else {
        focusable = scrollTarget.querySelector('[ref="addToCartButton"]:not([disabled]), button:not([disabled])');
      }
      var target = focusable || scrollTarget;
      if (!focusable && !target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }
      var delay = reduceMotion ? 0 : 450;
      window.setTimeout(function () {
        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          target.focus();
        }
      }, delay);
    });
  }
})();
